let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("is3Hu")).then(() => parcelRequire('5jzFu'));